import "./Footer.css";
import React from "react";

export const Footer = () => {
    return (
        <footer>
            <div id="creator_tag">
                <span>
                    made by:{" "}
                    <a
                        href="https://www.linkedin.com/in/mateusz-polis-65618223a/"
                        target="blank"
                    >
                        mateuszpolis
                    </a>
                </span>
            </div>
        </footer>
    );
};
